/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { ServiceTypeModelSearchResultModel } from '../../models/service-type-model-search-result-model';

export interface ServiceTypeSearchServiceTypePost$Params {
      body?: SearchRequestModel
}

export function serviceTypeSearchServiceTypePost(http: HttpClient, rootUrl: string, params?: ServiceTypeSearchServiceTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceTypeModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, serviceTypeSearchServiceTypePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ServiceTypeModelSearchResultModel>;
    })
  );
}

serviceTypeSearchServiceTypePost.PATH = '/ServiceType/SearchServiceType';
